import axiosPublicClient from "../../../../axiosPublicClient"

// Uploads one locally-selected file through the request-key-gated media-url endpoint; returns its key.
const uploadFile = async ({ requestKey, file, fileName, fileExtension }) => {
    const response = await axiosPublicClient.post('/document-request-media-url', {
        requestKey,
        fileName,
        fileExtension,
    })

    if (!response?.data?.url || !response?.data?.key) {
        throw new Error('Upload URL or key missing from response')
    }

    await axiosPublicClient.put(response.data.url, file, {
        headers: {
            'Content-Type': file.type,
        },
    })

    return response.data.key
}

// Same call shape as the pre-adverse submit service (`responseKey` is the request's link key here).
const submitDocumentRequestResponse = async ({ responseKey, comment, documents }) => {
    const uploadedDocuments = await Promise.all(
        (documents || []).map(async (document) => ({
            key: await uploadFile({
                requestKey: responseKey,
                file: document.file,
                fileName: document.fileName,
                fileExtension: document.fileExtension,
            }),
            fileName: document.originalName,
            requestedItemId: document.requestedItemId || null,
        }))
    )

    const result = await axiosPublicClient.post('/submit-document-request-response', {
        requestKey: responseKey,
        comment,
        documents: uploadedDocuments,
    })

    return result.data
}

export default submitDocumentRequestResponse
